<template>
  <div>
    <!-- PAGINA DASHBOARD -->
    <!-- <compliance-dash v-if="is_compliance"></compliance-dash> -->
    <template v-if="!loading_solutions">
      <resolve-dash v-if="is_resolve"></resolve-dash>
      <combat-dash v-if="is_corona"></combat-dash>
      
      <pallet-dash v-if="is_pallet"></pallet-dash>

      <router-view v-if="is_compliance"></router-view>
    </template>
    <template v-if="loading_solutions">
      <card-loading-transparent light></card-loading-transparent>
    </template>
    

  </div>
</template>
<script>
import { mapState, mapActions } from 'vuex'

export default {
  components:{
    ComplianceDash: () => import('@/components/reports/index/ComplianceDash.vue'),
    ResolveDash: () => import('@/components/reports/index/ResolveDash.vue'),
    CombatDash: () => import('@/components/reports/index/CombatDash.vue'),

    PalletDash: () => import('@/_reports/pallet/pages/PalletsDash.vue'),
  },
  methods: {
    checkRetail() {
      if (this.is_compliance){
        this.$router.push({name: 'MainRetailDashboard'})
      }
    },
    ...mapActions({
      indexDoneForm: 'DoneForm/index',
    })
  },

  computed:{
    is_compliance(){
      if (this.allSolutions){
        return this.allSolutions.find(obj=>obj.id==this.solutionID).proposal_name == 'compliance'
      }
      return false
    },
    is_quality(){
      if (this.allSolutions){
        return this.allSolutions.find(obj=>obj.id==this.solutionID).proposal_name == 'quality'
      }
      return false
    },
    is_safety(){
      if (this.allSolutions){
        return this.allSolutions.find(obj=>obj.id==this.solutionID).proposal_name == 'safety'
      }
      return false
    },
    is_production(){
      if (this.allSolutions){
        return this.allSolutions.find(obj=>obj.id==this.solutionID).proposal_name == 'production'
      }
      return false
    },
    is_resolve(){
      if (this.allSolutions){
        return this.allSolutions.find(obj=>obj.id==this.solutionID).proposal_name == 'resolve'
      }
      return false
    },
    is_corona(){
      if (this.allSolutions){
        return this.allSolutions.find(obj=>obj.id==this.solutionID).proposal_name == 'corona'
      }
      return false
    },
    is_pallet(){
      if (this.allSolutions){
        return this.allSolutions.find(obj=>obj.id==this.solutionID).proposal_name == 'pallet'
      }
      return false
    },
    ...mapState({
      allDoneForms: state => state.DoneForm.allDoneForms,
      loading_solutions: state => state.Solution.loading_solutions,
      solutionID: state => state.Solution.solutionID,
      allSolutions: state => state.Solution.allSolutions,

    })
  },
  created () {
    this.checkRetail()
    // this.indexDoneForm()
  },
  watch: {
    '$route.fullPath'(nv,ov) {
      if (nv){
        if (nv.split('/').pop() == 'dashboard'){
          // this.dash_kind = this.all_kinds[0].dash_component
          // this.$router.push({name: this.all_kinds[0].dash_component})
          this.checkRetail()
        } else {
          // this.dash_kind = this.$route.name
        }
        // console.log(nv.split('/'));
      } else if (nv == false){
      }
    }
  },
  
}
</script>